@if (isLoading()) {
  <div class="eva-conversation eva-initializing">
    <mat-spinner [diameter]="isExpanded() ? 100 : 80" />
  </div>
} @else {
  <div class="eva-conversation"
       [class.has-questions]="hasQuestions()"
       [class.chip-active]="isContextChipVisible()">


    <div class="eva-messages"
         cdkScrollable
         #conversationFeed>

      @for (questionAnswer of questionsAnswers().questionAndAnswers; track $index; let qaIndex = $index) {
        <div class="eva-question-group">
          <div class="eva-question mat-elevation-z1"
               #questionItem
               [class.new-response]="questionAnswer.isNewResponse && !isScrollAtBottom()">
            {{ questionAnswer.question }}
          </div>

          @if (questionAnswer.questionDate) {
            <div class="caption">{{ questionAnswer.questionDate | date: 'MM/dd/yyyy h:mm a' }}</div>
          }
        </div>

        <div class="eva-answer">
          <div class="eva-answer-title">EVA
            <mat-icon class="eva-logo"
                      svgIcon="eva"
                      small
                      color="accent" />
          </div>
          @if(questionAnswer.answer.shouldShowTextResponse) {
            <ez-eva-text-formatter [response]="questionAnswer.answer.response"
                                   [conversationId]="questionAnswer.answer.askEvaConversationId"
                                   (rendered)="onTextFormatterRendered()" />
          }

          @if(questionAnswer.answer?.response && showCatchMeUpHint()($index)) {
            <ez-alert>
              Helpful hint: {{ hintMessage }}
            </ez-alert>
          }

          @if(questionAnswer.answer?.data && !questionAnswer.answer?.shouldShowTextResponse) {
            @if(questionAnswer.answer.response && (questionAnswer.answer.data?.applicants?.length || questionAnswer.answer.data?.policies?.length)) {
              <ez-eva-text-formatter [response]="questionAnswer.answer.response"
                                     [conversationId]="questionAnswer.answer.askEvaConversationId"
                                     (rendered)="onTextFormatterRendered()" />
            }
            @for(item of questionAnswer.answer.primaryFieldNamesInData; track $index) {
              @if(item === evaAnswerTypes.Applicants && questionAnswer.answer.data?.applicants?.length) {
                <ez-eva-applicants (selectedApplicant)="onApplicantSelected($event, qaIndex)"
                                   [isHistoryLoaded]="questionAnswer.isHistoryLoaded ?? false"
                                   [applicantId]="questionAnswer.applicantId ?? null"
                                   [applicants]="questionAnswer.answer.data.applicants" />
              }
              @if(item === evaAnswerTypes.Policies && questionAnswer.answer.data?.policies?.length) {
                <ez-eva-policies (selectedPolicy)="onPolicySelected($event, qaIndex)"
                                 [isHistoryLoaded]="questionAnswer.isHistoryLoaded ?? false"
                                 [policyId]="questionAnswer.policyId ?? null"
                                 [policies]="questionAnswer.answer.data.policies" />
              }
            }
          }

          @if(questionAnswer.answer.hitl?.required) {
            <ez-eva-action-confirmation [hitl]="questionAnswer.answer.hitl!"
                                        [selectedOption]="questionAnswer.hitlSelectedOption"
                                        (optionSelected)="onActionOptionSelected($event, qaIndex)" />
          }

          @if($last && isCallingApi()) {
            <mat-progress-bar mode="indeterminate"
                              color="accent" />
            <div class="eva-loading-message">{{ loadingMessage() }}</div>
          }
          @if(questionAnswer.answer?.response && questionAnswer.answer?.requestId) {
            <ez-eva-feedback [answer]="questionAnswer.answer" />
          }
        </div>
      }

      @if (showScrollButton()) {
        <button type="button"
                mat-flat-button
                color="primary"
                class="scroll-latest"
                (click)="scrollToNewResponse()">
          <mat-icon>arrow_downward</mat-icon>
          New response
        </button>
      }
    </div>

    <div class="prompt-and-welcome">
      @if (!hasQuestions()) {
        <div class="eva-welcome">
          <div class="column dense eva-welcome-message">
            <div class="display-medium">Hi {{ firstName() }}, I'm EVA<mat-icon class="eva-logo"
                        svgIcon="eva"
                        color="accent"
                        small /></div>
            <div class="display-large welcome-subtext">Your personal AI-powered assistant, built right into EZLynx.</div>
          </div>
        </div>
      }
      <ez-eva-context />
      <ez-eva-prompt [inConversation]="hasQuestions()"
                     [isCallingApi]="isCallingApi()"
                     [hasPendingAction]="hasPendingConfirmation()"
                     [isProcessingAction]="isProcessingAction()"
                     [showStaticPrompts]="!hasQuestions()"
                     [excludedStaticPrompts]="excludedStaticPrompts()"
                     [suggestedPrompts]="visiblePromptPills()"
                     (suggestedPromptSelected)="onSuggestedPromptSelected($event)"
                     (promptSubmitted)="sendCurrentQuestion($event)" />
    </div>
  </div>
}